import noop from 'lodash/noop';
import type { InlineEditContext } from './types.tsx';

export const EMPTY_INLINE_EDIT_CONTEXT: InlineEditContext = {
	onCancel: noop,
	onConfirm: noop,
	onEdit: noop,
};
